// extracted by mini-css-extract-plugin
export default {"social":"social_social__+8Hyl","socialIcon":"social_socialIcon__jNK2c","socialLink":"social_socialLink__qEjJH"};